import * as React from 'react';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import CustomTable from '../../components/atoms/Table'
import ActionMenu from '../../components/atoms/ActionButton'

import { Box, Chip, IconButton, Paper, Switch, Tooltip, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SoftTypography from 'components/SoftTypography';
import SoftBox from 'components/SoftBox';
import service from '../../api/services';
import toast from 'react-hot-toast';
import { useAuth } from 'AuthContext';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';


const User = () => {
  const navigate = useNavigate()
  const [isApiLoading, setIsApiLoading] = React.useState(true)
  const [businessData, setBusinessData] = React.useState([]);
  const [search, setSearch] = React.useState('');
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isChecked, setIsChecked] = React.useState(false)
  const [sortValue, setSortValue] = React.useState({ sortKey: 'name', sortDirection: 'asc' });
  const items = [
    { label: 'Edit', onClick: () => { navigate(`/admin/edit-user/${'dsdfshq342345'}`) } },

  ];


  const columns = [
    {
      id: 'firstName', isSorting: true, sortDirection: 'asc', label: 'Name',
      render: (row) => (
        <SoftBox>
          <Typography align={'left'} sx={{
            color: '#000',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            fontSize: '1rem',
            fontWeight: 400,
            lineHeight: 1.6,
            letterSpacing: '0.01071em',
          }}
          >{row.firstName + ' ' + row.lastName}</Typography>
        </SoftBox>
      )

    },
    { id: 'email', isSorting: true, sortDirection: 'asc', label: 'Email' },
    {
      id: 'isActivated',
      label: 'Status', isSorting: true, sortDirection: 'asc',
      render: (row) => (
        <Box display="flex" alignItems="center" gap={1}>
          <Switch checked={row.isActivated} onChange={(i, b) => handleChangeStatus(row._id, b)} />
          <Typography variant="caption">{row.isActivated ? 'Active' : 'Inactive'}</Typography>
        </Box>
      ),
    },
    { id: 'subscriptionPlanStatus', isSorting: true, sortDirection: 'asc', label: 'Subscribers' ,
      render: (row) => (
        <Typography
          variant="caption"
          fontWeight="bold"
          color={row.subscriptionPlanStatus ? 'error' : 'success'}
        >
          {row?.subscriptionPlanStatus ? 'Yes' : 'No'}
        </Typography>
      ),

    },

    // {
    //   id: 'isSoftDelete',
    //   label: (
    //     <Box display="flex" alignItems="center" gap={0.5}>
    //       Soft Delete
    //       <Tooltip title="Deleted accounts can be recovered within 30 days" arrow>
    //         <InfoOutlinedIcon fontSize="small" sx={{ color: 'gray', cursor: 'pointer' }} />
    //       </Tooltip>
    //     </Box>
    //   ),
    //   isSorting: true,
    //   sortDirection: 'asc',
    //   render: (row) => (
    //     <Typography
    //       variant="caption"
    //       fontWeight="bold"
    //       color={row.isSoftDelete ? 'error' : 'success'}
    //     >
    //       {row.isSoftDelete ? 'Deleted' : 'Active'}
    //     </Typography>
    //   ),
    // },
    {
      id: 'action',
      label: 'Action',
      render: (row) => (
        <ActionMenu
          items={[
            { label: 'Detail', onClick: () => navigate(`/admin/detail-user/${row._id}`) },
            { label: 'Remove', onClick: () => deleteBusinessUser(row._id) },
          ]}
        />
      ),
    },
  ];


  const deleteBusinessUser = async (id) => {
    try {
      const response = await service.users.edit(id, { deletedAt: true });

      if (response?.status === 200 || response?.status === 201) {
        toast.success(response?.data?.message || 'User deleted successfully');
        await getUserDetail(); // Add `await` if it returns a promise
      } else {
        toast.error(response?.data?.message || 'Failed to delete user');
      }
    } catch (error) {
      const message =
        error?.response?.data?.message || 'Something went wrong. Please try again.';
      toast.error(message);
      console.error('Delete User Error:', error); // for dev debugging
    }
  };


  const getUserDetail = async () => {
    setIsApiLoading(true)
    try {
      const params = {
        userType: 'CUSTOMER',
        ...(isChecked ? { subscriber: isChecked } : {}),
        searchData: search,
        page,
        limit: rowsPerPage, sortKey: sortValue.sortKey, sortDirection: sortValue.sortDirection
      };
      const response = await service.users.view(params);
      if (response?.data?.data) {
        setBusinessData(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch business users", error);
    }
    setIsApiLoading(false)
  };

  const handleChangeStatus = async (id, type) => {
    try {
      let response = await service.users.edit(id, { isActivated: type })
      if (response.status === 201 || response.status === 200) {
        toast.success(response?.data?.message)
        getUserDetail()
      } else {
        toast.error(response?.data?.message)

      }
    } catch (error) {
      toast.error(error?.response?.data?.message)
    }
  }
  React.useEffect(() => {
    getUserDetail();
  }, [search, page, rowsPerPage, isChecked, sortValue]);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Paper className='glassmorphism-card' sx={{ padding: 2, mt: '15px' }}>
        <SoftBox display="flex" alignItems="center" justifyContent={'end'} gap={'5px'}>
          <Switch checked={isChecked} onChange={() => setIsChecked(!isChecked)} />
          <SoftTypography variant="caption">{isChecked ? 'Subscribers' : 'Subscribers'}</SoftTypography>
        </SoftBox>
        <CustomTable
          title="Business List" columns={columns}
          rows={businessData?.data}
          search={search}
          setSearch={setSearch}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          isApiLoading={isApiLoading}
          setRowsPerPage={setRowsPerPage}
          totalPages={businessData?.pagination?.totalItems}
          onRequestSort={(id, direction) => {
            setSortValue({ sortKey: id, sortDirection: direction })

          }}
        // order={order}
        // orderBy={orderBy}
        // onRequestSort={handleRequestSort}
        />
      </Paper>
    </DashboardLayout>
  );
}

export default User
